"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _request = _interopRequireDefault(require("../utils/request"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RiffRaff = /*#__PURE__*/function () {
  function RiffRaff(riffraffUrl, logger) {
    _classCallCheck(this, RiffRaff);

    _defineProperty(this, "request", void 0);

    _defineProperty(this, "riffraffUrl", void 0);

    this.riffraffUrl = riffraffUrl;
    this.request = new _request["default"](riffraffUrl, logger, true);
  }

  _createClass(RiffRaff, [{
    key: "getAccountInfoFromSubdomain",
    value: function () {
      var _getAccountInfoFromSubdomain = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(path) {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.request.get(path);

              case 2:
                result = _context.sent;
                return _context.abrupt("return", result.account);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAccountInfoFromSubdomain(_x) {
        return _getAccountInfoFromSubdomain.apply(this, arguments);
      }

      return getAccountInfoFromSubdomain;
    }()
  }, {
    key: "acceptApprisePolicy",
    value: function acceptApprisePolicy(accessToken) {
      var path = '/user/accept-apprise-policy';
      var body = {
        accessToken: accessToken
      };
      return this.request.put(path, body);
    }
  }, {
    key: "lookUpUser",
    value: function lookUpUser(accountId, emailOrRegcode) {
      var path = '/account/' + accountId + '/user-lookup/';
      var body = {
        query: emailOrRegcode
      };
      return this.request.post(body, path);
    }
  }, {
    key: "getAccessWithSecureCookie",
    value: function getAccessWithSecureCookie(createRefreshToken) {
      var path = '/sso-access';
      var body = {
        createRefreshToken: createRefreshToken
      };
      return this.request.post(body, path);
    }
  }, {
    key: "getUserByEmail",
    value: function getUserByEmail(accountId, email) {
      var path = '/account/' + accountId + '/get-user-by-email/';
      var body = {
        query: email
      };
      return this.request.post(body, path);
    }
  }, {
    key: "confirmRegCode",
    value: function confirmRegCode(accountId, regCode) {
      var path = '/account/' + accountId + '/confirm-reg-code/';
      var body = {
        query: regCode
      };
      return this.request.post(body, path);
    }
  }, {
    key: "loginUser",
    value: function loginUser(email, account, password, callbackUrl, mfaCode) {
      var path = '/auth/login';
      var body = {
        email: email,
        password: password,
        account: account,
        callbackUrl: callbackUrl,
        mfaCode: mfaCode
      };
      return this.request.post(body, path);
    }
  }, {
    key: "logout",
    value: function logout() {
      var path = '/auth/logout';
      return this.request.get(path);
    }
  }, {
    key: "getMessage",
    value: function getMessage() {
      var path = '/user/global-config';
      return this.request.get(path);
    }
  }, {
    key: "registerUser",
    value: function registerUser(password, email, account, name, firstName, lastName, registrationCode, openReg, application, appVersion, callbackUrl, subDomain) {
      var path = '/user/register';
      var body = {
        password: password,
        email: email,
        account: account,
        name: name,
        firstName: firstName,
        lastName: lastName,
        registrationCode: registrationCode,
        openReg: openReg,
        application: application,
        appVersion: appVersion,
        callbackUrl: callbackUrl,
        subDomain: subDomain
      };
      return this.request.post(body, path);
    }
  }, {
    key: "emailAvailable",
    value: function emailAvailable(value) {
      var path = '/user/email-available/';
      var body = {
        query: value
      };
      return this.request.post(body, path);
    }
  }, {
    key: "forgotPassword",
    value: function forgotPassword(email, account, subdomain) {
      var path = '/user/forgot-password';
      var body = {
        email: email,
        account: account,
        subdomain: subdomain
      };
      return this.request.post(body, path);
    }
  }, {
    key: "resetPassword",
    value: function resetPassword(token, password, repeatPassword) {
      var path = '/user/change-password';
      var body = {
        token: token,
        password: password,
        repeatPassword: repeatPassword
      };
      return this.request.put(path, body);
    }
  }, {
    key: "checkPassword",
    value: function checkPassword(token, password, repeatPassword) {
      var path = '/user/check-password';
      var body = {
        token: token,
        password: password,
        repeatPassword: repeatPassword
      };
      return this.request.put(path, body);
    }
  }, {
    key: "checkChangePassword",
    value: function checkChangePassword(email, password, repeatPassword, subdomain) {
      var path = '/user/check-change-password';
      var body = {
        email: email,
        password: password,
        repeatPassword: repeatPassword,
        subdomain: subdomain
      };
      return this.request.put(path, body);
    }
  }, {
    key: "resendVerificationEmail",
    value: function resendVerificationEmail(token) {
      var path = '/user/resend-email-verification';
      var body = {
        token: token
      };
      return this.request.post(body, path);
    }
  }, {
    key: "contactCustomerCare",
    value: function contactCustomerCare(accountId, name, email, subject, description, applicationName) {
      var path = '/user/contact-us';
      var body = {
        accountId: accountId,
        name: name,
        email: email,
        subject: subject,
        description: description,
        applicationName: applicationName
      };
      return this.request.post(body, path);
    }
  }, {
    key: "verifyEmail",
    value: function verifyEmail(token) {
      var path = '/user/email-verification';
      var body = {
        token: token
      };
      return this.request.put(path, body);
    }
  }, {
    key: "changeEmail",
    value: function changeEmail(email, newEmail, repeatEmail, password) {
      var path = '/user/change-email';
      var body = {
        email: email,
        newEmail: newEmail,
        repeatEmail: repeatEmail,
        password: password
      };
      return this.request.put(path, body);
    }
  }, {
    key: "changePasswordNoToken",
    value: function changePasswordNoToken(email, newPassword, repeatPassword, password, subDomain) {
      var path = '/user/change-password-no-token';
      var body = {
        email: email,
        password: password,
        newPassword: newPassword,
        repeatPassword: repeatPassword,
        subDomain: subDomain
      };
      return this.request.put(path, body);
    }
  }, {
    key: "updateUserData",
    value: function updateUserData(account, userId, email, firstName, lastName, password, accessToken) {
      var path = '/user/update-user-data';
      var body = {
        account: account,
        userId: userId,
        email: email,
        firstName: firstName,
        lastName: lastName,
        password: password,
        accessToken: accessToken
      };
      return this.request.post(body, path);
    }
  }, {
    key: "buildSSOLoginUrl",
    value: function buildSSOLoginUrl(accountId, SSOType, callbackUrl) {
      var url = this.riffraffUrl;

      switch (SSOType) {
        case 'ADFS_3_OAUTH':
          url = url + '/oauth/adfs/' + accountId;
          break;

        case 'PING_OAUTH':
          url = url + '/oauth/ping/' + accountId;
          break;

        case 'AZURE_AD_OAUTH':
          url = url + '/oauth/azure-ad/' + accountId;
          break;

        case 'OKTA_OAUTH':
          url = url + '/oauth/okta/' + accountId;
          break;

        case 'OKTA_SAML':
          url = url + '/saml/okta/' + accountId + "?RelayState=".concat(callbackUrl);
          break;

        case 'CUSTOM_OAUTH2':
          url = url + '/oauth/custom/' + accountId;
          break;

        case 'CUSTOM_SAML':
          url = url + '/saml/custom/' + accountId + "?RelayState=".concat(callbackUrl);
          break;

        case 'GOOGLE_OAUTH2':
          url = url + '/oauth/google/' + accountId;
          break;

        case 'ADFS_SAML':
          url = url + '/saml/adfs/' + accountId + "?RelayState=".concat(callbackUrl);
          break;

        default:
          throw new Error('INVALID SSOType');
      }

      return url;
    }
  }, {
    key: "validatePassword",
    value: function validatePassword(data) {
      var path = '/user/validate-password';
      return this.request.put(path, data);
    }
  }, {
    key: "ssoLogout",
    value: function ssoLogout() {
      var path = '/oauth/custom/logout';
      var body = {};
      return this.request.post(body, path);
    }
  }]);

  return RiffRaff;
}();

exports["default"] = RiffRaff;